import { combineReducers } from 'redux';

import { errorsReducer } from './errorsReducer';
import { layoutReducer } from './layoutReducer';
import { mapReducer } from './mapReducer';
import { portReducer } from './portReducer';
import { userReducer } from './userReducer';

const reducers = combineReducers({
    map: mapReducer,
    user: userReducer,
    port: portReducer,
    layout: layoutReducer,
    errors: errorsReducer,
});

export default reducers;
